module.exports = __webpack_public_path__ + "static/media/643.78cc75f7.webp";